import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import BasePageContainer from 'widgets/layout/BasePageContainer';

import styles from './styles';

const ProfileBasePageContainer = ({ children, classes, ...rest }) => (
  <BasePageContainer classes={{ contentContainer: classes.container }} {...rest}>
    {children}
  </BasePageContainer>
);

ProfileBasePageContainer.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
};

ProfileBasePageContainer.defaultProps = {
  children: null,
};

export default withStyles(styles)(ProfileBasePageContainer);
